import { Slider, styled } from '@mui/material';
import Styles from './style.module.scss'
import { useState } from 'react';

const StyledSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    display: 'none',
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

export default function RangeInput({
  min,
  defaultStartingPercentage=20,
  max,
  defaultEndPercentage=40,
  startLabel,
  endLabel
}) {
  const [value, setValue] = useState([defaultStartingPercentage, defaultEndPercentage])

  return (
    <div className={Styles.container}>
      <StyledSlider
        getAriaLabel={() => 'Range'}
        valueLabelDisplay="auto"
        aria-label="pretto slider"
        defaultValue={value}
        onChange={(event, newValue)=> setValue(newValue)}
        // components={{
        //   Mark: 
        // }}
      />
    </div>
  )
}